import { app } from '../../../../../app';
import { Controller } from './dropbox-provisioning-mapping.controller';

app.component('dropboxProvisioningMapping', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./dropbox-provisioning-mapping.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning-mapping/dropbox-provisioning-mapping.component.js